module.exports = wangEditor;